import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Header,
  Label,
  Page,
  QuestionContainer,
  QuestionLabel,
} from './styles';
import { ParticipantQuestionsComponents } from '../../../components/participant-questions-components';
import { questionTypes } from './constants';

const SurveyPageAnswers = (props) => {
  const { surveyPageAnswers } = props;

  return (
    <Container>
      <Header as="h3">
        {`Page ${surveyPageAnswers[0].page}`}
      </Header>

      <Page>
        {surveyPageAnswers.map((surveyPageAnswer) => {
          if (surveyPageAnswer.isSkipped) {
            // Entire page was skipped
            return (
              <Label key={`skip-${surveyPageAnswer.pageId}`}>
                {surveyPageAnswer.skippedPageMessage}
              </Label>
            );
          }

          if (surveyPageAnswer.isQuestionSkipped) {
            // Individual question was skipped
            return (
              <QuestionContainer>
                <QuestionLabel>
                  {`Question ${surveyPageAnswer.questionOrder + 1}:
                  ${surveyPageAnswer.questionLabel}
                  (${questionTypes[_.get(surveyPageAnswer, 'questionType', '')].replace(/\s*\(.*?\)/, '')})`}
                </QuestionLabel>
                <Label key={`skip-${surveyPageAnswer.questionId}`}>
                  {surveyPageAnswer.skippedQuestionMessage}
                </Label>
              </QuestionContainer>
            );
          }

          // Render the question and its answers normally
          return (
            <ParticipantQuestionsComponents
              key={surveyPageAnswer.questionId}
              surveyPageAnswer={surveyPageAnswer}
              index={surveyPageAnswer.questionOrder}
              typeQuestion={_.get(surveyPageAnswer, 'questionType', '')}
              totalAnswers={surveyPageAnswers.length}
            />
          );
        })}
      </Page>
    </Container>
  );
};

SurveyPageAnswers.propTypes = {
  surveyPageAnswers: PropTypes.instanceOf(Object).isRequired,
};

export default SurveyPageAnswers;
